import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const deleteTooltip = <Tooltip id="tooltip">Delete item from queue</Tooltip>;

const QueueDeleteButton = ({ action, args, disabled }) => {
  return (
    <OverlayTrigger placement="top" overlay={deleteTooltip}>
      <Button
        size="sm"
        variant="outline-secondary"
        className="queue-button"
        style={{ marginRight: '0.5em' }}
        disabled={disabled}
        onClick={e => {
          action(args);
          e.currentTarget.blur();
        }}
      >
        <FontAwesomeIcon icon={faTrash} />
      </Button>
    </OverlayTrigger>
  );
};

export default QueueDeleteButton;
